import React, { useState } from "react";
import ImageWidget1 from "../../images/widget-img-1.png";
import ImageWidget2 from "../../images/widget-img-2.png";
import ImageWidget3 from "../../images/widget-img-3.png";
import ImageWidget4 from "../../images/widget-img-4.png";
import ImageWidget5 from "../../images/widget-img-5.png";
import ImageWidget6 from "../../images/widget-img-6.png";
import ImageWidget7 from "../../images/widget-img-7.png";
import ImageWidget8 from "../../images/widget-img-8.png";
import ImageWidget9 from "../../images/widget-img-9.png";
import ImageWidget10 from "../../images/widget-img-10.png";
import ImageWidget11 from "../../images/widget-img-11.png";
import ImageWidget12 from "../../images/widget-img-12.png";
import ImageWidget13 from "../../images/widget-img-13.png";
import ImageWidget14 from "../../images/widget-img-14.png";
import ImageWidget15 from "../../images/widget-img-15.png";
import ImageWidget16 from "../../images/widget-img-16.png";
import ImageWidget17 from "../../images/widget-img-17.png";
import ImageWidget18 from "../../images/widget-img-18.png";
import InView from "react-intersection-observer";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import Parallax from "../common/utils/animations/parallax";

export default function CsDesignSystem() {
  const [isVisible, setisVisible] = useState(false);
  return (
    <div className="cs-desing-system-section  section-gap">
      <div className="container-small">
        <InView as="div" className="cs-desing-system-content" onChange={(inView) => setisVisible(inView)}>
          <p className="theme-color-title blue-color">{isVisible ? <HeaderAnim header="THE SALESMATE DESIGN SYSTEM" /> : ""}</p>
          <h3>Crafting flawless sales experience, consistently</h3>
          <p>Companies like Airbnb, Uber, Google, and Microsoft are launching beautiful products at a much faster pace than ever before have built their design systems. We built one for Salesmate. It eliminated the repeated UX/UI  work for the designer and allowed developers to reuse their components.</p>

          <p>With over 460+ reusable UI components, assets, and standards, our teams were able to design and develop new features in a matter of days. Every new feature delivered a clean and consistent experience.</p>

          <p>As the product evolved, we had to update the user experience and interactions. Due to the design system, we only have to change one component, and the entire platform gets updated. Feels like magic!</p>
        </InView>
      </div>

      <div className="widget-images-grid">
        <Parallax classes="widget-image-1" id="widget-image-1" triggers={[1, 0.6]} opacity={true} length={50}>
          <img src={ImageWidget1} alt="new lead" title="new lead" />
        </Parallax>
        <Parallax classes="widget-image-2" id="widget-image-2" triggers={[1, 0.6]} opacity={true} length={50}>
          <img src={ImageWidget2} alt="call transfer" title="call transfer" />
        </Parallax>
        <Parallax classes="widget-image-3" id="widget-image-3" triggers={[1, 0.6]} opacity={true} length={50}>
          <img src={ImageWidget3} alt="inbound and outbound calls" title="recent inbound and outbound calls" />
        </Parallax>
        <Parallax classes="widget-image-4" id="widget-image-4" triggers={[1, 0.6]} opacity={true} length={50}>
          <img src={ImageWidget4} alt="contact management" title="contact management" />
        </Parallax>
        <Parallax classes="widget-image-5" id="widget-image-5" triggers={[1, 0.6]} opacity={true} length={50}>
          <img src={ImageWidget5} alt="contact tag" title="contact tag" />
        </Parallax>
        <Parallax classes="widget-image-6" id="widget-image-6" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget6} alt="dropdown" title="dropdown" />
        </Parallax>
        <Parallax classes="widget-image-7" id="widget-image-7" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget7} alt="deals" title="deals" />
        </Parallax>
        <Parallax classes="widget-image-8" id="widget-image-8" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget8} alt="activity as action" title="activity as action" />
        </Parallax>
        <Parallax classes="widget-image-9" id="widget-image-9" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget9} alt="Widget" title="Widget" />
        </Parallax>
        <Parallax classes="widget-image-10" id="idget-image-10" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget10} alt="Widget" title="Widget" />
        </Parallax>
        <Parallax classes="widget-image-11" id="idget-image-11" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget11} alt="support" title="support" />
        </Parallax>
        <Parallax classes="widget-image-12" id="idget-image-12" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget12} alt="contact type select" title="contact type select" />
        </Parallax>
        <Parallax classes="widget-image-13" id="idget-image-13" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget13} alt="deal performance" title="deal performance" />
        </Parallax>
        <Parallax classes="widget-image-14" id="idget-image-14" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget14} alt="days sales outstanding" title="days sales outstanding" />
        </Parallax>
        <Parallax classes="widget-image-15" id="idget-image-15" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget15} alt="sorted" title="sorted" />
        </Parallax>
        <Parallax classes="widget-image-16" id="idget-image-16" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget16} alt="Widget 1" title="Widget 1" />
        </Parallax>
        <Parallax classes="widget-image-17" id="idget-image-17" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget17} alt="Widget 1" title="Widget 1" />
        </Parallax>
        <Parallax classes="widget-image-18" id="idget-image-18" triggers={[1, 0.6]} opacity={false} length={100}>
          <img src={ImageWidget18} alt="Widget 1" title="Widget 1" />
        </Parallax>
      </div>
    </div>
  );
}